import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// import './assets/css/vendor.css'
// import './assets/css/_user_list.css'

import './assets/css/style.css'


ReactDOM.render(<App />, document.getElementById('root'));
